<template>
  <div>
    <div class="header">ADMIN CODE</div>

    <div class="tabs">
      <div :class="['tab', {active:tab === 'command'}]" @click="tab = 'command'">
        <i class="fa fa-code fa-fw" aria-hidden="true"></i>
        Commands
      </div>
      <div :class="['tab', {active:tab === 'rsvp'}]" @click="tab = 'rsvp'">
        <i class="fa fa-id-card fa-fw" aria-hidden="true"></i>
        RSVP
      </div>
      <div :class="['tab', {active:tab === 'asap'}]" @click="tab = 'asap'">
        <i class="fa fa-id-card fa-fw" aria-hidden="true"></i>
        ASAP
      </div>
      <div :class="['tab', {active:tab === 'failed'}]" @click="tab = 'failed'">
        <i class="fa fa-eye fa-fw" aria-hidden="true"></i>
        Failed
      </div>
      <div :class="['tab', {active:tab === 'services'}]" @click="tab = 'services'">
        <i class="fa fa-globe fa-fw" aria-hidden="true"></i>
        Services
      </div>
    </div>

    <div class="tabs-content">
      <transition-group mode="out-in" name="slide-up">
        <div class="content" v-show="tab === 'command'" key="1">
          <commands />
        </div>
        <div class="content" v-show="tab === 'failed'" key="2">
          <failed ref="failed" />
        </div>
        <div class="content" v-show="tab === 'rsvp'" key="3">
          <rsvp ref="rsvp" />
        </div>
        <div class="content" v-show="tab === 'asap'" key="4">
          <asap ref="asap" />
        </div>
        <div class="content" v-show="tab === 'services'" key="5">
          <services ref="services" />
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import commands from './commands'
import failed from './failed'
import rsvp from './rsvp'
import asap from './asap'
import services from './services'

export default {
  name: 'admin-code',
  components: { commands, failed, rsvp, asap, services },
  data () {
    return {
      tab: 'command'
    }
  },
  computed: {
  },
  methods: {
  },
  watch: {
    tab (x) {
      if (x !== 'command') {
        if (this.$refs[x]) this.$refs[x].checkLoaded()
      }
    }
  },
  mounted () {
    let access = this.$store.state.session.user.access
    if (!access.hasOwnProperty('PageAdminCode')) this.$router.push({name: 'MissingPage'})
    // console.log('222', access.hasOwnProperty('PageAdminCode'))
  }
}
</script>

<style lang="scss" scoped>
.header{
  background: #fafafa;
  height: 50px;
  border-bottom: 2px solid #eee;
  line-height: 50px;
  padding-left: 60px;
  letter-spacing: .6px;
  color: #555;
  font-weight: 600;
  font-size: 21px;
  margin-bottom: 20px;
}

.tabs{
  display: flex;
  gap: 10px;
  border-bottom: 1px solid #ccc;

  .tab{
    padding: 10px 15px;
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    border-bottom: 4px solid transparent;
    font-weight: 600;
    color: #333;
    
    i{
      color: #999;
      margin-right: 5px;
    }
    &.active{
      border-bottom: 4px solid #57D1B7;
      color: #57D1B7;

      i{
        color: #b1dad1;
      }
    }
  }
}

.content{
  background: #fafafa;
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .25s ease-in-out; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .tabs {
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AdminCode/index.vue